import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import * as ROUTES from '../../constants/routes';

class WerkgeverOverzichtBase extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading:false,
      users:[],
      company:'',
    };
  }

  componentDidMount() {
    this.setState({
      loading:true
    });

    if (!this.props.company) {
      this.setState({ loading: false });
      return;
    }

    this.usersQuery = this.props.firebase.usersByCompany(this.props.company);
    this.usersQuery.on('value', snapshot => {
      this.setState({
        users: this.props.firebase.snapshotToList(snapshot),
        loading: false,
      });
    });
  }

  componentWillUnmount() {
    if (this.usersQuery) {
      this.usersQuery.off();
    }
  }

render() {
  const { users, loading } = this.state;
  // console.log('company', this.props.company)

  return (
      <div className="Overzicht-werknemers">
       <div className="Goed-te-keuren-werknemers">
         <h2>Nog goed te keuren werknemers</h2>
         {loading && <div>Loading...</div>}
          <table className="Tabel-full-width">
            <tbody>
              <tr>
                <th>Naam</th><th>E-mailadres</th><th>Details</th>
              </tr>
              {users
                .sort((a, b) => {
                  if (a.username < b.username) {
                    return -1;
                  }
                  if (a.username > b.username) {
                    return 1;
                  }
                  return 0;
                })
                .filter(user => user.roles && user.roles.WERKNEMER === "WERKNEMER")
                .filter(user => user.isAkkoord === false)
                .map(user => (
              <tr key={user.uid}>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td><Link to={{
                  pathname: `${ROUTES.WERKGEVER}/werknemer/${user.uid}`,
                  state: { user },
                }}
                >
                  Details
                </Link></td>
            </tr>
            ))}
          </tbody>
        </table>
      </div>


        <div className="Werkgever-buttons">
          <Link to={{
            pathname: `${ROUTES.WERKGEVER}/deelnemers`,
            }}
          >
            <div className="Deelnemers">
              <h3>Deelnemers fietsplan</h3>
            </div>
          </Link>

          <Link to={{
            pathname: `${ROUTES.WERKGEVER_POOL_OBJECTS}`,
            state: {companyName: this.props.company}
            }}
            >
            <div className="Facturen">
              <h3>Poolobjecten</h3>
            </div>
          </Link>

          <Link to={{
            pathname: `${ROUTES.WERKGEVER_FACTUREN}`,
            state: {companyName: this.props.company}
            }}
            >
            <div className="Facturen">
              <h3>Facturen</h3>
            </div>
          </Link>

        </div>
    </div>
  )
  }
}

export default WerkgeverOverzichtBase;
